export default ({ eventBus, eventDefinitions, context }) => {
  eventBus.$on(eventDefinitions.PRODUCT.CLICK, ({ product }) => {
    //
  })
}
